// Document Ready
$(document).ready(function() {
    if ($('#anmeldungIndustriekultur-14506, #anmeldungIndustriekultur-21034, #anmeldungIndustriekultur-23616').length > 0) {
        $('input[type="checkbox"]').each(function() {
            // wenn der Textknoten "AUSGEBUCHT!!!" hinterlegt hat, dann soll die Checkbox auf disabled gesetzt werden
            if ($(this).next().text().indexOf('AUSGEBUCHT') > -1) {
                $(this).next().css({
                    opacity: 0.6,
                    cursor: 'not-allowed'
                });
                $(this).attr('disabled', 'disabled');
            }

            // wenn im Textknoten (EN) vorkomment, soll die EN Flagge anghängt werden // Taken from https://uxwing.com/united-kingdom-flag-icon/
            if ($(this).next().text().indexOf('(EN)') > -1) {
                $(this).closest('label').css('color', '#0536a5');
                var that = $(this).next();
                var thatNew = that.text().replace('(EN)', '<img src="/fileadmin/projects/industriekultur/img/flag_en.webp" style="width: 22px; margin-top: -2px" alt="EN">');
                that.html(thatNew);
            }
        });

        $('div.clearfix p').each(function() {
            // wenn im Textknoten (EN) vorkomment, soll die EN Flagge anghängt werden // Taken from https://uxwing.com/united-kingdom-flag-icon/
            if ($(this).text().indexOf('(EN)') > -1) {
                $(this).css('color', '#0536a5');
                var that = $(this);
                var thatNew = $(this).text().replace('(EN)', '<img src="/fileadmin/projects/industriekultur/img/flag_en.webp" style="width: 22px; margin-top: -2px" alt="EN">');
                that.html(thatNew);
            }
        });

        // Absenden Button auf der letzten Seite auf "Absenden / Submit" ändern
        $('button.btn-primary[value="3"]').text('Absenden / Submit');
    }
});